import api from '@pray/shared/utils/api/api';

import type { GetSegmentResponse } from './data/response';

/**
 * Get segment options for creating lead segments
 */
export async function getSegment(artistId: string, segmentId: string) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!segmentId) throw new Error('Segment ID is required');

  const url = `/web/studio/artists/${artistId}/lead-segments/${segmentId}`;
  const response = await api.executeGetRequest<GetSegmentResponse>(url);

  return response.data;
}
